<!-- choose-optional-holiday-dialog.component.html -->

<div class="coh-dialog">
  <!-- Header -->
  <div class="coh-header">
    <h2 class="coh-title">Choose Optional Holidays - {{ year }}</h2>
    <button class="coh-close" (click)="onCancel()">
      {{ 'leave_management.choose_optional_holiday_dialog.x2715' | transloco }}
    </button>
  </div>

  <div class="coh-body">
    <!-- AG-Grid holiday table -->
    <div class="coh-grid-wrap">
      <ers-grid
        [rowData]="availableHolidays"
        [columnDefs]="colDefs"
        [gridOptions]="gridOptions"
        (gridReady)="onGridReady($event)"
      >
      </ers-grid>

      @if (availableHolidays.length === 0) {
      <p class="coh-empty">
        {{
          'leave_management.choose_optional_holiday_dialog.no_optional_holidays_available_in_calendar'
            | transloco
        }}
      </p>
      }
    </div>

    <!-- Note -->
    <p class="coh-note">
      <span class="coh-note-star">*</span
      >{{
        'leave_management.choose_optional_holiday_dialog.note_any_6_optional_holidays_can_be_availed'
          | transloco
      }}
    </p>

    <!-- Supervisor selection -->
    <div class="coh-section">
      <label class="coh-label"
        >Submit Request to<span class="coh-required">*</span></label
      >

      <mat-form-field class="coh-select-field" appearance="outline">
        <mat-select
          [(ngModel)]="selectedSupervisorId"
          [placeholder]="
            'leave_management.choose_optional_holiday_dialog.placeholder.select_supervisor'
              | transloco
          "
        >
          @for (sup of supervisors | ersSortBy: 'supervisorName'; track sup.id)
          {
          <mat-option [value]="sup.id">
            {{ sup.supervisorName }}
          </mat-option>
          }
        </mat-select>
      </mat-form-field>

      <!-- Selected supervisor tag -->
      @if (selectedSupervisorId) {
      <div class="coh-tag-row">
        <span class="coh-tag">
          {{ selectedSupervisorName }}
          <button class="coh-tag-remove" (click)="removeSupervisor()">
            {{
              'leave_management.choose_optional_holiday_dialog.x2715'
                | transloco
            }}
          </button>
        </span>
      </div>
      }
    </div>
  </div>

  <!-- Footer actions -->
  <div class="coh-actions">
    <button class="lm-btn lm-btn--reset" (click)="onCancel()">
      {{ 'leave_management.choose_optional_holiday_dialog.cancel' | transloco }}
    </button>
    <button
      class="lm-btn lm-btn--success"
      [disabled]="!canSubmit || isSubmitting"
      (click)="onSubmit()"
    >
      {{
        'leave_management.choose_optional_holiday_dialog.submit_request'
          | transloco
      }}
    </button>
  </div>
</div>
